import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { configurationSubject } from './app/environment-resolver';
import { IConfig } from './app/config.interface';

const isLocalhost: boolean = location.host.includes('localhost');
let configFile = './assets/config.json';

if (isLocalhost) {
  const isDev: boolean = document.referrer.includes('upmchpdev.') || sessionStorage.getItem('isLocalDev') === 'true';
  const isStg: boolean = sessionStorage.getItem('isLocalStg') === 'true'; // TODO: troubleshoot issue with following: || JSON.parse(atob(location.href.split('=')[1]?.split('.')[1])).acr.includes('stg');

  if (isDev) {
    configFile = './assets/transforms/config.localdev.json';
    sessionStorage.setItem('isLocalDev', 'true');
  } else {
    sessionStorage.removeItem('isLocalDev');
  }

  if (isStg) {
    configFile = './assets/transforms/config.localstg.json';
    sessionStorage.setItem('isLocalStg', 'true');
  } else {
    sessionStorage.removeItem('isLocalStg');
  }
} else {
  sessionStorage.removeItem('isLocalDev');
  sessionStorage.removeItem('isLocalStg');
}

fetch(configFile)
  .then((response) => response.json())
  .then((config: IConfig) => {
    window.ENVIRONMENT = Object.assign({}, config.environment);
    window['OAUTH_CONFIG'] = Object.assign({}, config.oauth);
    /* eslint-enable */
    configurationSubject.next(config);

    if (config.environment.production === true) {
      enableProdMode();
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch(() => window.location.reload());
